{
  "formatVersion": 1,
  "name": "blackline-reactor",
  "displayName": "Reactor",
  "description": "A nuclear power plant under an overcast sky: attackers spawn in an asphalt yard at the west end, a long service road runs the north side to the defenders, and the roofed reactor hall fills the middle — the bombsite at A on a railed platform up a stair run, the one at B in the sunken turbine pit off the hall’s south side, reached by three stairs.",
  "visual": null,
  "environment": "overcast",
  "brushes": [
    {
      "kind": "box",
      "center": [
        0,
        -1.75,
        7.5
      ],
      "halfExtents": [
        45,
        1.75,
        27.5
      ],
      "material": "concrete",
      "note": "plant floor, top at y=0 (reference brush)"
    },
    {
      "kind": "box",
      "center": [
        -20.5,
        -1.75,
        -27.5
      ],
      "halfExtents": [
        24.5,
        1.75,
        7.5
      ],
      "material": "concrete",
      "note": "south-west floor"
    },
    {
      "kind": "box",
      "center": [
        32.5,
        -1.75,
        -27.5
      ],
      "halfExtents": [
        12.5,
        1.75,
        7.5
      ],
      "material": "concrete",
      "note": "south-east floor"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.75,
        -34
      ],
      "halfExtents": [
        8,
        1.75,
        1
      ],
      "material": "concrete",
      "note": "floor behind the pit"
    },
    {
      "kind": "box",
      "center": [
        12,
        -3,
        -26.5
      ],
      "halfExtents": [
        8,
        0.5,
        6.5
      ],
      "material": "metal",
      "note": "turbine pit floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        -34.75
      ],
      "halfExtents": [
        45,
        3.5,
        0.25
      ],
      "material": "concrete",
      "note": "perimeter north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        34.75
      ],
      "halfExtents": [
        45,
        3.5,
        0.25
      ],
      "material": "concrete",
      "note": "perimeter south wall"
    },
    {
      "kind": "box",
      "center": [
        44.75,
        3.5,
        0
      ],
      "halfExtents": [
        0.25,
        3.5,
        34.5
      ],
      "material": "concrete",
      "note": "perimeter east wall"
    },
    {
      "kind": "box",
      "center": [
        -44.75,
        3.5,
        0
      ],
      "halfExtents": [
        0.25,
        3.5,
        34.5
      ],
      "material": "concrete",
      "note": "perimeter west wall"
    },
    {
      "kind": "box",
      "center": [
        -37.25,
        -0.14,
        0.3
      ],
      "halfExtents": [
        7.25,
        0.15,
        19.3
      ],
      "material": "asphalt",
      "note": "outside yard asphalt"
    },
    {
      "kind": "box",
      "center": [
        -37.5,
        0.02,
        -12
      ],
      "halfExtents": [
        5.5,
        0.01,
        0.1
      ],
      "material": "paint",
      "note": "bay line"
    },
    {
      "kind": "box",
      "center": [
        -37.5,
        0.02,
        -4
      ],
      "halfExtents": [
        5.5,
        0.01,
        0.1
      ],
      "material": "paint",
      "note": "bay line"
    },
    {
      "kind": "box",
      "center": [
        -37.5,
        0.02,
        4
      ],
      "halfExtents": [
        5.5,
        0.01,
        0.1
      ],
      "material": "paint",
      "note": "bay line"
    },
    {
      "kind": "box",
      "center": [
        -37.5,
        0.02,
        12
      ],
      "halfExtents": [
        5.5,
        0.01,
        0.1
      ],
      "material": "paint",
      "note": "bay line"
    },
    {
      "kind": "box",
      "center": [
        -33,
        1.75,
        -19.2
      ],
      "halfExtents": [
        3,
        1.75,
        0.2
      ],
      "material": "concrete",
      "note": "yard south wall"
    },
    {
      "kind": "box",
      "center": [
        -34,
        1.75,
        19.8
      ],
      "halfExtents": [
        4,
        1.75,
        0.2
      ],
      "material": "concrete",
      "note": "yard north wall"
    },
    {
      "kind": "box",
      "center": [
        -33,
        0.81,
        -15
      ],
      "halfExtents": [
        0.8,
        0.8,
        0.8
      ],
      "material": "metal",
      "hidden": true,
      "note": "yard crate collision"
    },
    {
      "kind": "box",
      "center": [
        -33,
        0.81,
        17
      ],
      "halfExtents": [
        0.8,
        0.8,
        0.8
      ],
      "material": "metal",
      "hidden": true,
      "note": "yard crate collision"
    },
    {
      "kind": "box",
      "center": [
        -43.5,
        4,
        -17
      ],
      "halfExtents": [
        0.15,
        4,
        0.15
      ],
      "material": "metal",
      "note": "flood mast"
    },
    {
      "kind": "box",
      "center": [
        -43.5,
        4,
        19
      ],
      "halfExtents": [
        0.15,
        4,
        0.15
      ],
      "material": "metal",
      "note": "flood mast"
    },
    {
      "kind": "box",
      "center": [
        -30.6,
        3,
        -4
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "yard wall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -30.6,
        3,
        8
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "yard wall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -26.25,
        1.75,
        -15.8
      ],
      "halfExtents": [
        1.75,
        1.75,
        0.2
      ],
      "material": "brick",
      "note": "lobby north wall"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        2.95,
        -15.8
      ],
      "halfExtents": [
        1,
        0.55,
        0.2
      ],
      "material": "brick",
      "note": "lobby north lintel"
    },
    {
      "kind": "box",
      "center": [
        -20.75,
        1.75,
        -15.8
      ],
      "halfExtents": [
        1.75,
        1.75,
        0.2
      ],
      "material": "brick",
      "note": "lobby north wall"
    },
    {
      "kind": "box",
      "center": [
        -25.5,
        1.75,
        -7.2
      ],
      "halfExtents": [
        2.5,
        1.75,
        0.2
      ],
      "material": "brick",
      "note": "lobby south wall"
    },
    {
      "kind": "box",
      "center": [
        -22.3,
        0.5,
        -7.2
      ],
      "halfExtents": [
        0.7,
        0.5,
        0.2
      ],
      "material": "brick",
      "note": "lobby south sill"
    },
    {
      "kind": "box",
      "center": [
        -22.3,
        2.75,
        -7.2
      ],
      "halfExtents": [
        0.7,
        0.75,
        0.2
      ],
      "material": "brick",
      "note": "lobby south lintel"
    },
    {
      "kind": "box",
      "center": [
        -20.3,
        1.75,
        -7.2
      ],
      "halfExtents": [
        1.3,
        1.75,
        0.2
      ],
      "material": "brick",
      "note": "lobby south wall"
    },
    {
      "kind": "box",
      "center": [
        -19.2,
        1.75,
        -14.55
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.05
      ],
      "material": "brick",
      "note": "lobby east wall"
    },
    {
      "kind": "box",
      "center": [
        -19.2,
        2.95,
        -12.5
      ],
      "halfExtents": [
        0.2,
        0.55,
        1
      ],
      "material": "brick",
      "note": "lobby east lintel"
    },
    {
      "kind": "box",
      "center": [
        -19.2,
        1.75,
        -9.45
      ],
      "halfExtents": [
        0.2,
        1.75,
        2.05
      ],
      "material": "brick",
      "note": "lobby east wall"
    },
    {
      "kind": "box",
      "center": [
        -27.8,
        1.75,
        -13.05
      ],
      "halfExtents": [
        0.2,
        1.75,
        2.55
      ],
      "material": "brick",
      "note": "lobby west wall"
    },
    {
      "kind": "box",
      "center": [
        -27.8,
        2.95,
        -9.5
      ],
      "halfExtents": [
        0.2,
        0.55,
        1
      ],
      "material": "brick",
      "note": "lobby west lintel"
    },
    {
      "kind": "box",
      "center": [
        -27.8,
        1.75,
        -7.95
      ],
      "halfExtents": [
        0.2,
        1.75,
        0.55
      ],
      "material": "brick",
      "note": "lobby west wall"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        3.65,
        -11.5
      ],
      "halfExtents": [
        4.5,
        0.15,
        4.5
      ],
      "material": "concrete",
      "note": "lobby roof"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        -0.14,
        -11.5
      ],
      "halfExtents": [
        4.5,
        0.15,
        4.5
      ],
      "material": "tile",
      "note": "lobby floor"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        0.46,
        -14.5
      ],
      "halfExtents": [
        1,
        0.45,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "lobby desk collision"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        3.1,
        -11.5
      ],
      "halfExtents": [
        0.5,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#fff4dc",
      "emissiveIntensity": 3,
      "note": "lobby lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -25,
        1.75,
        3.2
      ],
      "halfExtents": [
        3,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "hut north wall"
    },
    {
      "kind": "box",
      "center": [
        -21.3,
        0.5,
        3.2
      ],
      "halfExtents": [
        0.7,
        0.5,
        0.2
      ],
      "material": "panel",
      "note": "hut north sill"
    },
    {
      "kind": "box",
      "center": [
        -21.3,
        2.75,
        3.2
      ],
      "halfExtents": [
        0.7,
        0.75,
        0.2
      ],
      "material": "panel",
      "note": "hut north lintel"
    },
    {
      "kind": "box",
      "center": [
        -19.8,
        1.75,
        3.2
      ],
      "halfExtents": [
        0.8,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "hut north wall"
    },
    {
      "kind": "box",
      "center": [
        -27,
        1.75,
        11.8
      ],
      "halfExtents": [
        1,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "hut south wall"
    },
    {
      "kind": "box",
      "center": [
        -25,
        2.95,
        11.8
      ],
      "halfExtents": [
        1,
        0.55,
        0.2
      ],
      "material": "panel",
      "note": "hut south lintel"
    },
    {
      "kind": "box",
      "center": [
        -21.5,
        1.75,
        11.8
      ],
      "halfExtents": [
        2.5,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "hut south wall"
    },
    {
      "kind": "box",
      "center": [
        -19.2,
        1.75,
        5.95
      ],
      "halfExtents": [
        0.2,
        1.75,
        2.55
      ],
      "material": "panel",
      "note": "hut east wall"
    },
    {
      "kind": "box",
      "center": [
        -19.2,
        2.95,
        9.5
      ],
      "halfExtents": [
        0.2,
        0.55,
        1
      ],
      "material": "panel",
      "note": "hut east lintel"
    },
    {
      "kind": "box",
      "center": [
        -19.2,
        1.75,
        11.05
      ],
      "halfExtents": [
        0.2,
        1.75,
        0.55
      ],
      "material": "panel",
      "note": "hut east wall"
    },
    {
      "kind": "box",
      "center": [
        -27.8,
        1.75,
        3.95
      ],
      "halfExtents": [
        0.2,
        1.75,
        0.55
      ],
      "material": "panel",
      "note": "hut west wall"
    },
    {
      "kind": "box",
      "center": [
        -27.8,
        2.95,
        5.5
      ],
      "halfExtents": [
        0.2,
        0.55,
        1
      ],
      "material": "panel",
      "note": "hut west lintel"
    },
    {
      "kind": "box",
      "center": [
        -27.8,
        1.75,
        9.05
      ],
      "halfExtents": [
        0.2,
        1.75,
        2.55
      ],
      "material": "panel",
      "note": "hut west wall"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        3.65,
        7.5
      ],
      "halfExtents": [
        4.5,
        0.15,
        4.5
      ],
      "material": "metal",
      "note": "hut roof"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        -0.14,
        7.5
      ],
      "halfExtents": [
        4.5,
        0.15,
        4.5
      ],
      "material": "concrete",
      "note": "hut floor"
    },
    {
      "kind": "box",
      "center": [
        -21,
        0.51,
        5
      ],
      "halfExtents": [
        0.5,
        0.5,
        0.5
      ],
      "material": "metal",
      "hidden": true,
      "note": "hut crate collision"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        3.1,
        7.5
      ],
      "halfExtents": [
        0.5,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#fff4dc",
      "emissiveIntensity": 3,
      "note": "hut lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        1,
        -2
      ],
      "halfExtents": [
        1.2,
        1,
        0.9
      ],
      "material": "metal",
      "hidden": true,
      "note": "mini transformer collision"
    },
    {
      "kind": "box",
      "center": [
        -18.6,
        3.2,
        -6
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "mini lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -18.6,
        3.2,
        2
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "mini lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -14.5,
        4.5,
        -17.7
      ],
      "halfExtents": [
        1.5,
        4.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        -2.5,
        3.25,
        -17.7
      ],
      "halfExtents": [
        10.5,
        3.25,
        0.3
      ],
      "material": "concrete",
      "note": "hall north sill"
    },
    {
      "kind": "box",
      "center": [
        -2.5,
        8.5,
        -17.7
      ],
      "halfExtents": [
        10.5,
        0.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        9,
        4.5,
        -17.7
      ],
      "halfExtents": [
        1,
        4.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        12,
        6,
        -17.7
      ],
      "halfExtents": [
        2,
        3,
        0.3
      ],
      "material": "concrete",
      "note": "hall north lintel"
    },
    {
      "kind": "box",
      "center": [
        15,
        4.5,
        -17.7
      ],
      "halfExtents": [
        1,
        4.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall north wall"
    },
    {
      "kind": "box",
      "center": [
        -15,
        4.5,
        15.7
      ],
      "halfExtents": [
        1,
        4.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        -10,
        3.25,
        15.7
      ],
      "halfExtents": [
        4,
        3.25,
        0.3
      ],
      "material": "concrete",
      "note": "hall south sill"
    },
    {
      "kind": "box",
      "center": [
        -10,
        8.5,
        15.7
      ],
      "halfExtents": [
        4,
        0.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        -5.5,
        4.5,
        15.7
      ],
      "halfExtents": [
        0.5,
        4.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        -3.5,
        6,
        15.7
      ],
      "halfExtents": [
        1.5,
        3,
        0.3
      ],
      "material": "concrete",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        -1,
        4.5,
        15.7
      ],
      "halfExtents": [
        1,
        4.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        7,
        3.25,
        15.7
      ],
      "halfExtents": [
        7,
        3.25,
        0.3
      ],
      "material": "concrete",
      "note": "hall south sill"
    },
    {
      "kind": "box",
      "center": [
        7,
        8.5,
        15.7
      ],
      "halfExtents": [
        7,
        0.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall south lintel"
    },
    {
      "kind": "box",
      "center": [
        15,
        4.5,
        15.7
      ],
      "halfExtents": [
        1,
        4.5,
        0.3
      ],
      "material": "concrete",
      "note": "hall south wall"
    },
    {
      "kind": "box",
      "center": [
        15.7,
        4.5,
        -11.7
      ],
      "halfExtents": [
        0.3,
        4.5,
        5.7
      ],
      "material": "concrete",
      "note": "hall east wall"
    },
    {
      "kind": "box",
      "center": [
        15.7,
        6,
        -4.5
      ],
      "halfExtents": [
        0.3,
        3,
        1.5
      ],
      "material": "concrete",
      "note": "hall east lintel"
    },
    {
      "kind": "box",
      "center": [
        15.7,
        4.5,
        0.5
      ],
      "halfExtents": [
        0.3,
        4.5,
        3.5
      ],
      "material": "concrete",
      "note": "hall east wall"
    },
    {
      "kind": "box",
      "center": [
        15.7,
        6,
        5.5
      ],
      "halfExtents": [
        0.3,
        3,
        1.5
      ],
      "material": "concrete",
      "note": "hall east lintel"
    },
    {
      "kind": "box",
      "center": [
        15.7,
        4.5,
        11.2
      ],
      "halfExtents": [
        0.3,
        4.5,
        4.2
      ],
      "material": "concrete",
      "note": "hall east wall"
    },
    {
      "kind": "box",
      "center": [
        -15.7,
        4.5,
        -14.7
      ],
      "halfExtents": [
        0.3,
        4.5,
        2.7
      ],
      "material": "concrete",
      "note": "hall west wall"
    },
    {
      "kind": "box",
      "center": [
        -15.7,
        6,
        -10.5
      ],
      "halfExtents": [
        0.3,
        3,
        1.5
      ],
      "material": "concrete",
      "note": "hall west lintel"
    },
    {
      "kind": "box",
      "center": [
        -15.7,
        4.5,
        -0.5
      ],
      "halfExtents": [
        0.3,
        4.5,
        8.5
      ],
      "material": "concrete",
      "note": "hall west wall"
    },
    {
      "kind": "box",
      "center": [
        -15.7,
        6,
        9.5
      ],
      "halfExtents": [
        0.3,
        3,
        1.5
      ],
      "material": "concrete",
      "note": "hall west lintel"
    },
    {
      "kind": "box",
      "center": [
        -15.7,
        4.5,
        13.2
      ],
      "halfExtents": [
        0.3,
        4.5,
        2.2
      ],
      "material": "concrete",
      "note": "hall west wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        9.2,
        -1
      ],
      "halfExtents": [
        16,
        0.2,
        17
      ],
      "material": "concrete",
      "note": "hall roof"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.14,
        -1
      ],
      "halfExtents": [
        15.4,
        0.15,
        16.4
      ],
      "material": "tile",
      "note": "hall floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        -7
      ],
      "halfExtents": [
        3.5,
        3.5,
        3
      ],
      "material": "metal",
      "note": "reactor core"
    },
    {
      "kind": "box",
      "center": [
        0,
        7.4,
        -7
      ],
      "halfExtents": [
        2.6,
        0.4,
        2.2
      ],
      "material": "rust",
      "note": "reactor core cap"
    },
    {
      "kind": "box",
      "center": [
        -3.9,
        1.2,
        -7
      ],
      "halfExtents": [
        0.3,
        1.2,
        1.5
      ],
      "material": "panel",
      "note": "core buttress"
    },
    {
      "kind": "box",
      "center": [
        3.9,
        1.2,
        -7
      ],
      "halfExtents": [
        0.3,
        1.2,
        1.5
      ],
      "material": "panel",
      "note": "core buttress"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.25,
        7
      ],
      "halfExtents": [
        8,
        1.25,
        5
      ],
      "material": "concrete",
      "note": "site A platform"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.075,
        -1.722
      ],
      "halfExtents": [
        2,
        0.075,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.15,
        -1.497
      ],
      "halfExtents": [
        2,
        0.15,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.225,
        -1.272
      ],
      "halfExtents": [
        2,
        0.225,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.3,
        -1.047
      ],
      "halfExtents": [
        2,
        0.3,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.375,
        -0.822
      ],
      "halfExtents": [
        2,
        0.375,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.45,
        -0.597
      ],
      "halfExtents": [
        2,
        0.45,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.525,
        -0.372
      ],
      "halfExtents": [
        2,
        0.525,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.6,
        -0.147
      ],
      "halfExtents": [
        2,
        0.6,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.675,
        0.078
      ],
      "halfExtents": [
        2,
        0.675,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 9"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.75,
        0.303
      ],
      "halfExtents": [
        2,
        0.75,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 10"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.825,
        0.528
      ],
      "halfExtents": [
        2,
        0.825,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 11"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.9,
        0.753
      ],
      "halfExtents": [
        2,
        0.9,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 12"
    },
    {
      "kind": "box",
      "center": [
        -4,
        0.975,
        0.978
      ],
      "halfExtents": [
        2,
        0.975,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 13"
    },
    {
      "kind": "box",
      "center": [
        -4,
        1.05,
        1.203
      ],
      "halfExtents": [
        2,
        1.05,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 14"
    },
    {
      "kind": "box",
      "center": [
        -4,
        1.125,
        1.428
      ],
      "halfExtents": [
        2,
        1.125,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 15"
    },
    {
      "kind": "box",
      "center": [
        -4,
        1.2,
        1.653
      ],
      "halfExtents": [
        2,
        1.2,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 16"
    },
    {
      "kind": "box",
      "center": [
        -4,
        1.25,
        1.878
      ],
      "halfExtents": [
        2,
        1.25,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 17"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.075,
        -1.722
      ],
      "halfExtents": [
        2,
        0.075,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 1"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.15,
        -1.497
      ],
      "halfExtents": [
        2,
        0.15,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 2"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.225,
        -1.272
      ],
      "halfExtents": [
        2,
        0.225,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 3"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.3,
        -1.047
      ],
      "halfExtents": [
        2,
        0.3,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 4"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.375,
        -0.822
      ],
      "halfExtents": [
        2,
        0.375,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 5"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.45,
        -0.597
      ],
      "halfExtents": [
        2,
        0.45,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 6"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.525,
        -0.372
      ],
      "halfExtents": [
        2,
        0.525,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 7"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.6,
        -0.147
      ],
      "halfExtents": [
        2,
        0.6,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 8"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.675,
        0.078
      ],
      "halfExtents": [
        2,
        0.675,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 9"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.75,
        0.303
      ],
      "halfExtents": [
        2,
        0.75,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 10"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.825,
        0.528
      ],
      "halfExtents": [
        2,
        0.825,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 11"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.9,
        0.753
      ],
      "halfExtents": [
        2,
        0.9,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 12"
    },
    {
      "kind": "box",
      "center": [
        4,
        0.975,
        0.978
      ],
      "halfExtents": [
        2,
        0.975,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 13"
    },
    {
      "kind": "box",
      "center": [
        4,
        1.05,
        1.203
      ],
      "halfExtents": [
        2,
        1.05,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 14"
    },
    {
      "kind": "box",
      "center": [
        4,
        1.125,
        1.428
      ],
      "halfExtents": [
        2,
        1.125,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 15"
    },
    {
      "kind": "box",
      "center": [
        4,
        1.2,
        1.653
      ],
      "halfExtents": [
        2,
        1.2,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 16"
    },
    {
      "kind": "box",
      "center": [
        4,
        1.25,
        1.878
      ],
      "halfExtents": [
        2,
        1.25,
        0.113
      ],
      "material": "concrete",
      "note": "site A stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -7.95,
        3,
        7
      ],
      "halfExtents": [
        0.05,
        0.5,
        5
      ],
      "material": "metal",
      "note": "site A rail"
    },
    {
      "kind": "box",
      "center": [
        7.95,
        3,
        7
      ],
      "halfExtents": [
        0.05,
        0.5,
        5
      ],
      "material": "metal",
      "note": "site A rail"
    },
    {
      "kind": "box",
      "center": [
        -4.7,
        3,
        11.95
      ],
      "halfExtents": [
        3.2,
        0.5,
        0.05
      ],
      "material": "metal",
      "note": "site A rail"
    },
    {
      "kind": "box",
      "center": [
        4.7,
        3,
        11.95
      ],
      "halfExtents": [
        3.2,
        0.5,
        0.05
      ],
      "material": "metal",
      "note": "site A rail"
    },
    {
      "kind": "box",
      "center": [
        -6.95,
        3,
        2.05
      ],
      "halfExtents": [
        0.95,
        0.5,
        0.05
      ],
      "material": "metal",
      "note": "site A rail"
    },
    {
      "kind": "box",
      "center": [
        0,
        3,
        2.05
      ],
      "halfExtents": [
        1.9,
        0.5,
        0.05
      ],
      "material": "metal",
      "note": "site A rail"
    },
    {
      "kind": "box",
      "center": [
        6.95,
        3,
        2.05
      ],
      "halfExtents": [
        0.95,
        0.5,
        0.05
      ],
      "material": "metal",
      "note": "site A rail"
    },
    {
      "kind": "box",
      "center": [
        -5.5,
        3.4,
        8.5
      ],
      "halfExtents": [
        1.2,
        0.9,
        0.6
      ],
      "material": "panel",
      "note": "A cabinet"
    },
    {
      "kind": "box",
      "center": [
        5.5,
        3.4,
        8.5
      ],
      "halfExtents": [
        1.2,
        0.9,
        0.6
      ],
      "material": "panel",
      "note": "A cabinet"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.1,
        6
      ],
      "halfExtents": [
        0.9,
        0.6,
        0.9
      ],
      "material": "rust",
      "note": "A valve block"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.81,
        -12
      ],
      "halfExtents": [
        0.9,
        0.8,
        0.9
      ],
      "material": "metal",
      "hidden": true,
      "note": "hall generator collision"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.81,
        0
      ],
      "halfExtents": [
        0.9,
        0.8,
        0.9
      ],
      "material": "metal",
      "hidden": true,
      "note": "hall generator collision"
    },
    {
      "kind": "box",
      "center": [
        -12,
        1.01,
        2
      ],
      "halfExtents": [
        0.9,
        1,
        0.9
      ],
      "material": "metal",
      "hidden": true,
      "note": "hall tank collision"
    },
    {
      "kind": "box",
      "center": [
        -12,
        0.41,
        -13
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "hall pipe collision"
    },
    {
      "kind": "box",
      "center": [
        -9,
        0.41,
        -13
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "hall pipe collision"
    },
    {
      "kind": "box",
      "center": [
        -7,
        0.51,
        -3
      ],
      "halfExtents": [
        0.5,
        0.5,
        0.5
      ],
      "material": "metal",
      "hidden": true,
      "note": "hall crate collision"
    },
    {
      "kind": "box",
      "center": [
        7,
        0.51,
        -14
      ],
      "halfExtents": [
        0.5,
        0.5,
        0.5
      ],
      "material": "metal",
      "hidden": true,
      "note": "hall crate collision"
    },
    {
      "kind": "box",
      "center": [
        -10,
        7.2,
        -13
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -10,
        7.2,
        -1
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -10,
        7.2,
        11
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0,
        7.2,
        -13
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0,
        7.2,
        -1
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0,
        7.2,
        11
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        10,
        7.2,
        -13
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        10,
        7.2,
        -1
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        10,
        7.2,
        11
      ],
      "halfExtents": [
        0.6,
        0.06,
        0.2
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "hall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -15,
        3.4,
        -10.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall west door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -17,
        3.4,
        -10.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall west door lamp outside fixture"
    },
    {
      "kind": "box",
      "center": [
        -15,
        3.4,
        9.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall west door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -17,
        3.4,
        9.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall west door lamp outside fixture"
    },
    {
      "kind": "box",
      "center": [
        15,
        3.4,
        -4.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall east door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        17,
        3.4,
        -4.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall east door lamp outside fixture"
    },
    {
      "kind": "box",
      "center": [
        15,
        3.4,
        5.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall east door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        17,
        3.4,
        5.5
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall east door lamp outside fixture"
    },
    {
      "kind": "box",
      "center": [
        12,
        3.4,
        -17
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall pit door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        12,
        3.4,
        -19
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall pit door lamp outside fixture"
    },
    {
      "kind": "box",
      "center": [
        -3.5,
        3.4,
        15
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall road door lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -3.5,
        3.4,
        17
      ],
      "halfExtents": [
        0.35,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "hall road door lamp outside fixture"
    },
    {
      "kind": "box",
      "center": [
        -6.5,
        5.1,
        3
      ],
      "halfExtents": [
        0.12,
        0.06,
        0.12
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "A lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        6.5,
        5.1,
        3
      ],
      "halfExtents": [
        0.12,
        0.06,
        0.12
      ],
      "material": "metal",
      "emissive": "#fff1d6",
      "emissiveIntensity": 3,
      "note": "A lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -20.25,
        -0.14,
        -27.25
      ],
      "halfExtents": [
        24.25,
        0.15,
        7.25
      ],
      "material": "gravel",
      "note": "squeaky gravel"
    },
    {
      "kind": "box",
      "center": [
        -29.8,
        1.75,
        -30.25
      ],
      "halfExtents": [
        0.2,
        1.75,
        4.25
      ],
      "material": "concrete",
      "note": "squeaky wall"
    },
    {
      "kind": "box",
      "center": [
        -29.8,
        1.75,
        -21.5
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.5
      ],
      "material": "concrete",
      "note": "squeaky wall"
    },
    {
      "kind": "box",
      "center": [
        -20,
        0.41,
        -33.2
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "squeaky pipe collision"
    },
    {
      "kind": "box",
      "center": [
        -16.8,
        0.41,
        -33.2
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "squeaky pipe collision"
    },
    {
      "kind": "box",
      "center": [
        -13.6,
        0.41,
        -33.2
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "squeaky pipe collision"
    },
    {
      "kind": "box",
      "center": [
        -8,
        0.81,
        -26
      ],
      "halfExtents": [
        0.8,
        0.8,
        0.8
      ],
      "material": "metal",
      "hidden": true,
      "note": "squeaky crate collision"
    },
    {
      "kind": "box",
      "center": [
        -26,
        3.6,
        -34.1
      ],
      "halfExtents": [
        0.3,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "squeaky lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -14,
        3.6,
        -34.1
      ],
      "halfExtents": [
        0.3,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "squeaky lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -2,
        3.6,
        -34.1
      ],
      "halfExtents": [
        0.3,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "squeaky lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        12,
        -2.425,
        -23.722
      ],
      "halfExtents": [
        1.5,
        0.075,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 1"
    },
    {
      "kind": "box",
      "center": [
        12,
        -2.35,
        -23.498
      ],
      "halfExtents": [
        1.5,
        0.15,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 2"
    },
    {
      "kind": "box",
      "center": [
        12,
        -2.275,
        -23.272
      ],
      "halfExtents": [
        1.5,
        0.225,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 3"
    },
    {
      "kind": "box",
      "center": [
        12,
        -2.2,
        -23.047
      ],
      "halfExtents": [
        1.5,
        0.3,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 4"
    },
    {
      "kind": "box",
      "center": [
        12,
        -2.125,
        -22.822
      ],
      "halfExtents": [
        1.5,
        0.375,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 5"
    },
    {
      "kind": "box",
      "center": [
        12,
        -2.05,
        -22.597
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 6"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.975,
        -22.373
      ],
      "halfExtents": [
        1.5,
        0.525,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 7"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.9,
        -22.147
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 8"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.825,
        -21.922
      ],
      "halfExtents": [
        1.5,
        0.675,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 9"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.75,
        -21.697
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 10"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.675,
        -21.472
      ],
      "halfExtents": [
        1.5,
        0.825,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 11"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.6,
        -21.248
      ],
      "halfExtents": [
        1.5,
        0.9,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 12"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.525,
        -21.022
      ],
      "halfExtents": [
        1.5,
        0.975,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 13"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.45,
        -20.797
      ],
      "halfExtents": [
        1.5,
        1.05,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 14"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.375,
        -20.572
      ],
      "halfExtents": [
        1.5,
        1.125,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 15"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.3,
        -20.347
      ],
      "halfExtents": [
        1.5,
        1.2,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 16"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.25,
        -20.123
      ],
      "halfExtents": [
        1.5,
        1.25,
        0.113
      ],
      "material": "concrete",
      "note": "pit hall stair step 17"
    },
    {
      "kind": "box",
      "center": [
        7.723,
        -2.425,
        -27
      ],
      "halfExtents": [
        0.113,
        0.075,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 1"
    },
    {
      "kind": "box",
      "center": [
        7.498,
        -2.35,
        -27
      ],
      "halfExtents": [
        0.113,
        0.15,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 2"
    },
    {
      "kind": "box",
      "center": [
        7.273,
        -2.275,
        -27
      ],
      "halfExtents": [
        0.113,
        0.225,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 3"
    },
    {
      "kind": "box",
      "center": [
        7.048,
        -2.2,
        -27
      ],
      "halfExtents": [
        0.113,
        0.3,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 4"
    },
    {
      "kind": "box",
      "center": [
        6.823,
        -2.125,
        -27
      ],
      "halfExtents": [
        0.113,
        0.375,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 5"
    },
    {
      "kind": "box",
      "center": [
        6.598,
        -2.05,
        -27
      ],
      "halfExtents": [
        0.113,
        0.45,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 6"
    },
    {
      "kind": "box",
      "center": [
        6.373,
        -1.975,
        -27
      ],
      "halfExtents": [
        0.113,
        0.525,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 7"
    },
    {
      "kind": "box",
      "center": [
        6.148,
        -1.9,
        -27
      ],
      "halfExtents": [
        0.113,
        0.6,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 8"
    },
    {
      "kind": "box",
      "center": [
        5.922,
        -1.825,
        -27
      ],
      "halfExtents": [
        0.113,
        0.675,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 9"
    },
    {
      "kind": "box",
      "center": [
        5.698,
        -1.75,
        -27
      ],
      "halfExtents": [
        0.113,
        0.75,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 10"
    },
    {
      "kind": "box",
      "center": [
        5.473,
        -1.675,
        -27
      ],
      "halfExtents": [
        0.113,
        0.825,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 11"
    },
    {
      "kind": "box",
      "center": [
        5.248,
        -1.6,
        -27
      ],
      "halfExtents": [
        0.113,
        0.9,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 12"
    },
    {
      "kind": "box",
      "center": [
        5.023,
        -1.525,
        -27
      ],
      "halfExtents": [
        0.113,
        0.975,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 13"
    },
    {
      "kind": "box",
      "center": [
        4.797,
        -1.45,
        -27
      ],
      "halfExtents": [
        0.113,
        1.05,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 14"
    },
    {
      "kind": "box",
      "center": [
        4.573,
        -1.375,
        -27
      ],
      "halfExtents": [
        0.113,
        1.125,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 15"
    },
    {
      "kind": "box",
      "center": [
        4.348,
        -1.3,
        -27
      ],
      "halfExtents": [
        0.113,
        1.2,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 16"
    },
    {
      "kind": "box",
      "center": [
        4.123,
        -1.25,
        -27
      ],
      "halfExtents": [
        0.113,
        1.25,
        2
      ],
      "material": "concrete",
      "note": "pit west stair step 17"
    },
    {
      "kind": "box",
      "center": [
        16.278,
        -2.425,
        -30
      ],
      "halfExtents": [
        0.113,
        0.075,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 1"
    },
    {
      "kind": "box",
      "center": [
        16.502,
        -2.35,
        -30
      ],
      "halfExtents": [
        0.113,
        0.15,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 2"
    },
    {
      "kind": "box",
      "center": [
        16.728,
        -2.275,
        -30
      ],
      "halfExtents": [
        0.113,
        0.225,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 3"
    },
    {
      "kind": "box",
      "center": [
        16.953,
        -2.2,
        -30
      ],
      "halfExtents": [
        0.113,
        0.3,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 4"
    },
    {
      "kind": "box",
      "center": [
        17.178,
        -2.125,
        -30
      ],
      "halfExtents": [
        0.113,
        0.375,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 5"
    },
    {
      "kind": "box",
      "center": [
        17.403,
        -2.05,
        -30
      ],
      "halfExtents": [
        0.113,
        0.45,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 6"
    },
    {
      "kind": "box",
      "center": [
        17.627,
        -1.975,
        -30
      ],
      "halfExtents": [
        0.113,
        0.525,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 7"
    },
    {
      "kind": "box",
      "center": [
        17.853,
        -1.9,
        -30
      ],
      "halfExtents": [
        0.113,
        0.6,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 8"
    },
    {
      "kind": "box",
      "center": [
        18.078,
        -1.825,
        -30
      ],
      "halfExtents": [
        0.113,
        0.675,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 9"
    },
    {
      "kind": "box",
      "center": [
        18.303,
        -1.75,
        -30
      ],
      "halfExtents": [
        0.113,
        0.75,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 10"
    },
    {
      "kind": "box",
      "center": [
        18.528,
        -1.675,
        -30
      ],
      "halfExtents": [
        0.113,
        0.825,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 11"
    },
    {
      "kind": "box",
      "center": [
        18.752,
        -1.6,
        -30
      ],
      "halfExtents": [
        0.113,
        0.9,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 12"
    },
    {
      "kind": "box",
      "center": [
        18.978,
        -1.525,
        -30
      ],
      "halfExtents": [
        0.113,
        0.975,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 13"
    },
    {
      "kind": "box",
      "center": [
        19.203,
        -1.45,
        -30
      ],
      "halfExtents": [
        0.113,
        1.05,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 14"
    },
    {
      "kind": "box",
      "center": [
        19.428,
        -1.375,
        -30
      ],
      "halfExtents": [
        0.113,
        1.125,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 15"
    },
    {
      "kind": "box",
      "center": [
        19.653,
        -1.3,
        -30
      ],
      "halfExtents": [
        0.113,
        1.2,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 16"
    },
    {
      "kind": "box",
      "center": [
        19.877,
        -1.25,
        -30
      ],
      "halfExtents": [
        0.113,
        1.25,
        2
      ],
      "material": "concrete",
      "note": "pit east stair step 17"
    },
    {
      "kind": "box",
      "center": [
        12,
        -1.5,
        -27.5
      ],
      "halfExtents": [
        1.4,
        1,
        1
      ],
      "material": "metal",
      "hidden": true,
      "note": "pit turbine collision"
    },
    {
      "kind": "box",
      "center": [
        7,
        -2.1,
        -31.5
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "pit pipe collision"
    },
    {
      "kind": "box",
      "center": [
        17,
        -2.1,
        -31.5
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "pit pipe collision"
    },
    {
      "kind": "box",
      "center": [
        7,
        0.5,
        -19.95
      ],
      "halfExtents": [
        3,
        0.5,
        0.05
      ],
      "material": "metal",
      "note": "pit rim rail"
    },
    {
      "kind": "box",
      "center": [
        17,
        0.5,
        -19.95
      ],
      "halfExtents": [
        3,
        0.5,
        0.05
      ],
      "material": "metal",
      "note": "pit rim rail"
    },
    {
      "kind": "box",
      "center": [
        12,
        2.45,
        -24
      ],
      "halfExtents": [
        8,
        0.15,
        0.2
      ],
      "material": "rust",
      "note": "pit crane rail"
    },
    {
      "kind": "box",
      "center": [
        8,
        2,
        -24
      ],
      "halfExtents": [
        0.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffe9c4",
      "emissiveIntensity": 3,
      "note": "pit lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        16,
        2,
        -24
      ],
      "halfExtents": [
        0.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffe9c4",
      "emissiveIntensity": 3,
      "note": "pit lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        12,
        2.45,
        -31
      ],
      "halfExtents": [
        8,
        0.15,
        0.2
      ],
      "material": "rust",
      "note": "pit crane rail"
    },
    {
      "kind": "box",
      "center": [
        8,
        2,
        -31
      ],
      "halfExtents": [
        0.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffe9c4",
      "emissiveIntensity": 3,
      "note": "pit lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        16,
        2,
        -31
      ],
      "halfExtents": [
        0.4,
        0.06,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffe9c4",
      "emissiveIntensity": 3,
      "note": "pit lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        1.5,
        3.4,
        -27
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "pit west stair lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        22.5,
        3.4,
        -30
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "pit east stair lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        1.5,
        1.7,
        -27
      ],
      "halfExtents": [
        0.08,
        1.7,
        0.08
      ],
      "material": "metal",
      "note": "lamp post"
    },
    {
      "kind": "box",
      "center": [
        22.5,
        1.7,
        -30
      ],
      "halfExtents": [
        0.08,
        1.7,
        0.08
      ],
      "material": "metal",
      "note": "lamp post"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.14,
        27.25
      ],
      "halfExtents": [
        44.5,
        0.15,
        7.25
      ],
      "material": "asphalt",
      "note": "ramp road asphalt"
    },
    {
      "kind": "box",
      "center": [
        0,
        0.02,
        27.3
      ],
      "halfExtents": [
        40,
        0.01,
        0.1
      ],
      "material": "paint",
      "note": "road centre line"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.55,
        19.8
      ],
      "halfExtents": [
        6,
        0.55,
        0.2
      ],
      "material": "concrete",
      "note": "road kerb wall"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.55,
        19.8
      ],
      "halfExtents": [
        4,
        0.55,
        0.2
      ],
      "material": "concrete",
      "note": "road kerb wall"
    },
    {
      "kind": "box",
      "center": [
        6.5,
        0.55,
        19.8
      ],
      "halfExtents": [
        7.5,
        0.55,
        0.2
      ],
      "material": "concrete",
      "note": "road kerb wall"
    },
    {
      "kind": "box",
      "center": [
        24,
        0.55,
        19.8
      ],
      "halfExtents": [
        6,
        0.55,
        0.2
      ],
      "material": "concrete",
      "note": "road kerb wall"
    },
    {
      "kind": "box",
      "center": [
        -10,
        1.01,
        18
      ],
      "halfExtents": [
        1.2,
        1,
        0.9
      ],
      "material": "metal",
      "hidden": true,
      "note": "north transformer collision"
    },
    {
      "kind": "box",
      "center": [
        8,
        1.01,
        18
      ],
      "halfExtents": [
        1.2,
        1,
        0.9
      ],
      "material": "metal",
      "hidden": true,
      "note": "north transformer collision"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.41,
        33.3
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "road pipe collision"
    },
    {
      "kind": "box",
      "center": [
        -20.8,
        0.41,
        33.3
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "road pipe collision"
    },
    {
      "kind": "box",
      "center": [
        20.8,
        0.41,
        33.3
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "road pipe collision"
    },
    {
      "kind": "box",
      "center": [
        24,
        0.41,
        33.3
      ],
      "halfExtents": [
        1,
        0.4,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "road pipe collision"
    },
    {
      "kind": "box",
      "center": [
        -12,
        1.3,
        30
      ],
      "halfExtents": [
        3,
        1.3,
        1.2
      ],
      "material": "rust",
      "note": "road container"
    },
    {
      "kind": "box",
      "center": [
        14,
        1.3,
        24
      ],
      "halfExtents": [
        3,
        1.3,
        1.2
      ],
      "material": "rust",
      "note": "road container"
    },
    {
      "kind": "box",
      "center": [
        30,
        0.81,
        31
      ],
      "halfExtents": [
        0.8,
        0.8,
        0.8
      ],
      "material": "metal",
      "hidden": true,
      "note": "road crate collision"
    },
    {
      "kind": "box",
      "center": [
        -36,
        4.5,
        34.1
      ],
      "halfExtents": [
        0.35,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "road lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -24,
        4.5,
        34.1
      ],
      "halfExtents": [
        0.35,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "road lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -12,
        4.5,
        34.1
      ],
      "halfExtents": [
        0.35,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "road lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0,
        4.5,
        34.1
      ],
      "halfExtents": [
        0.35,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "road lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        12,
        4.5,
        34.1
      ],
      "halfExtents": [
        0.35,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "road lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        24,
        4.5,
        34.1
      ],
      "halfExtents": [
        0.35,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "road lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        36,
        4.5,
        34.1
      ],
      "halfExtents": [
        0.35,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "road lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        23.5,
        1.75,
        -5.8
      ],
      "halfExtents": [
        2.5,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "control room north wall"
    },
    {
      "kind": "box",
      "center": [
        27,
        2.95,
        -5.8
      ],
      "halfExtents": [
        1,
        0.55,
        0.2
      ],
      "material": "panel",
      "note": "control room north lintel"
    },
    {
      "kind": "box",
      "center": [
        28.5,
        1.75,
        -5.8
      ],
      "halfExtents": [
        0.5,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "control room north wall"
    },
    {
      "kind": "box",
      "center": [
        21.5,
        1.75,
        5.8
      ],
      "halfExtents": [
        0.5,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "control room south wall"
    },
    {
      "kind": "box",
      "center": [
        23,
        2.95,
        5.8
      ],
      "halfExtents": [
        1,
        0.55,
        0.2
      ],
      "material": "panel",
      "note": "control room south lintel"
    },
    {
      "kind": "box",
      "center": [
        26.5,
        1.75,
        5.8
      ],
      "halfExtents": [
        2.5,
        1.75,
        0.2
      ],
      "material": "panel",
      "note": "control room south wall"
    },
    {
      "kind": "box",
      "center": [
        28.8,
        1.75,
        -2.05
      ],
      "halfExtents": [
        0.2,
        1.75,
        3.55
      ],
      "material": "panel",
      "note": "control room east wall"
    },
    {
      "kind": "box",
      "center": [
        28.8,
        2.95,
        2.5
      ],
      "halfExtents": [
        0.2,
        0.55,
        1
      ],
      "material": "panel",
      "note": "control room east lintel"
    },
    {
      "kind": "box",
      "center": [
        28.8,
        1.75,
        4.55
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.05
      ],
      "material": "panel",
      "note": "control room east wall"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        1.75,
        -5.05
      ],
      "halfExtents": [
        0.2,
        1.75,
        0.55
      ],
      "material": "panel",
      "note": "control room west wall"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        2.95,
        -3.5
      ],
      "halfExtents": [
        0.2,
        0.55,
        1
      ],
      "material": "panel",
      "note": "control room west lintel"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        1.75,
        -0.75
      ],
      "halfExtents": [
        0.2,
        1.75,
        1.75
      ],
      "material": "panel",
      "note": "control room west wall"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        0.5,
        2.5
      ],
      "halfExtents": [
        0.2,
        0.5,
        1.5
      ],
      "material": "panel",
      "note": "control room west sill"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        2.75,
        2.5
      ],
      "halfExtents": [
        0.2,
        0.75,
        1.5
      ],
      "material": "panel",
      "note": "control room west lintel"
    },
    {
      "kind": "box",
      "center": [
        21.2,
        1.75,
        4.8
      ],
      "halfExtents": [
        0.2,
        1.75,
        0.8
      ],
      "material": "panel",
      "note": "control room west wall"
    },
    {
      "kind": "box",
      "center": [
        25,
        3.65,
        0
      ],
      "halfExtents": [
        4,
        0.15,
        6
      ],
      "material": "concrete",
      "note": "control room roof"
    },
    {
      "kind": "box",
      "center": [
        25,
        -0.14,
        0
      ],
      "halfExtents": [
        4,
        0.15,
        6
      ],
      "material": "tile",
      "note": "control room floor"
    },
    {
      "kind": "box",
      "center": [
        25,
        0.46,
        4.5
      ],
      "halfExtents": [
        1,
        0.45,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "control desk collision"
    },
    {
      "kind": "box",
      "center": [
        25,
        0.46,
        -4.5
      ],
      "halfExtents": [
        1,
        0.45,
        0.4
      ],
      "material": "metal",
      "hidden": true,
      "note": "control desk collision"
    },
    {
      "kind": "box",
      "center": [
        25,
        3.1,
        0
      ],
      "halfExtents": [
        0.5,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#fff4dc",
      "emissiveIntensity": 3,
      "note": "control room lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        20.2,
        3.2,
        -3.5
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "control room west lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        29.8,
        3.2,
        2.5
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "control room east lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        27,
        3.2,
        -6.8
      ],
      "halfExtents": [
        0.3,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "control room north lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        23,
        3.2,
        6.8
      ],
      "halfExtents": [
        0.3,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "control room south lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        38.75,
        -0.14,
        1
      ],
      "halfExtents": [
        5.75,
        0.15,
        17
      ],
      "material": "gravel",
      "note": "defenders yard gravel"
    },
    {
      "kind": "box",
      "center": [
        36,
        1.75,
        -16.2
      ],
      "halfExtents": [
        3,
        1.75,
        0.2
      ],
      "material": "concrete",
      "note": "defenders south wall"
    },
    {
      "kind": "box",
      "center": [
        37,
        1.75,
        18.2
      ],
      "halfExtents": [
        4,
        1.75,
        0.2
      ],
      "material": "concrete",
      "note": "defenders north wall"
    },
    {
      "kind": "box",
      "center": [
        35,
        0.81,
        -13
      ],
      "halfExtents": [
        0.8,
        0.8,
        0.8
      ],
      "material": "metal",
      "hidden": true,
      "note": "defenders crate collision"
    },
    {
      "kind": "box",
      "center": [
        35,
        0.81,
        15
      ],
      "halfExtents": [
        0.8,
        0.8,
        0.8
      ],
      "material": "metal",
      "hidden": true,
      "note": "defenders crate collision"
    },
    {
      "kind": "box",
      "center": [
        43.5,
        4,
        -14
      ],
      "halfExtents": [
        0.15,
        4,
        0.15
      ],
      "material": "metal",
      "note": "flood mast"
    },
    {
      "kind": "box",
      "center": [
        43.5,
        4,
        16
      ],
      "halfExtents": [
        0.15,
        4,
        0.15
      ],
      "material": "metal",
      "note": "flood mast"
    },
    {
      "kind": "box",
      "center": [
        33.6,
        3,
        -8
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "yard wall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        33.6,
        3,
        10
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "yard wall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        19.2,
        1.75,
        -13
      ],
      "halfExtents": [
        0.2,
        1.75,
        5
      ],
      "material": "concrete",
      "note": "east blast wall"
    },
    {
      "kind": "box",
      "center": [
        19.2,
        1.75,
        13
      ],
      "halfExtents": [
        0.2,
        1.75,
        4
      ],
      "material": "concrete",
      "note": "east blast wall"
    },
    {
      "kind": "box",
      "center": [
        19.2,
        3.7,
        -13
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "blast wall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        19.2,
        3.7,
        13
      ],
      "halfExtents": [
        0.1,
        0.06,
        0.3
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "blast wall lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        28,
        0.81,
        -26
      ],
      "halfExtents": [
        0.8,
        0.8,
        0.8
      ],
      "material": "metal",
      "hidden": true,
      "note": "south-east crate collision"
    },
    {
      "kind": "box",
      "center": [
        32,
        3.6,
        -34.1
      ],
      "halfExtents": [
        0.3,
        0.06,
        0.1
      ],
      "material": "metal",
      "emissive": "#e8f0ff",
      "emissiveIntensity": 3,
      "note": "south-east lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -30.6,
        1.475,
        -4
      ],
      "halfExtents": [
        0.04,
        1.465,
        0.04
      ],
      "material": "metal",
      "note": "yard wall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -29.25,
        3,
        8
      ],
      "halfExtents": [
        1.25,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "yard wall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        3.325,
        -11.5
      ],
      "halfExtents": [
        0.04,
        0.175,
        0.04
      ],
      "material": "metal",
      "note": "lobby lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -23.5,
        3.325,
        7.5
      ],
      "halfExtents": [
        0.04,
        0.175,
        0.04
      ],
      "material": "metal",
      "note": "hut lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -17.25,
        3.2,
        -6
      ],
      "halfExtents": [
        1.25,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "mini lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -17.25,
        3.2,
        2
      ],
      "halfExtents": [
        1.25,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "mini lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -10,
        8.13,
        -13
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -10,
        8.13,
        -1
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -10,
        8.13,
        11
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        0,
        8.13,
        -13
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        0,
        8.13,
        -1
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        0,
        8.13,
        11
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        10,
        8.13,
        -13
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        10,
        8.13,
        -1
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        10,
        8.13,
        11
      ],
      "halfExtents": [
        0.04,
        0.87,
        0.04
      ],
      "material": "metal",
      "note": "hall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -16.325,
        3.4,
        -10.5
      ],
      "halfExtents": [
        0.325,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall west door lamp outside fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -16.325,
        3.4,
        9.5
      ],
      "halfExtents": [
        0.325,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall west door lamp outside fixture mount"
    },
    {
      "kind": "box",
      "center": [
        16.325,
        3.4,
        -4.5
      ],
      "halfExtents": [
        0.325,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall east door lamp outside fixture mount"
    },
    {
      "kind": "box",
      "center": [
        16.325,
        3.4,
        5.5
      ],
      "halfExtents": [
        0.325,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "hall east door lamp outside fixture mount"
    },
    {
      "kind": "box",
      "center": [
        12,
        3.4,
        -17.26
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.14
      ],
      "material": "metal",
      "note": "hall pit door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        12,
        3.4,
        -18.44
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.44
      ],
      "material": "metal",
      "note": "hall pit door lamp outside fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -3.5,
        3.4,
        15.26
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.14
      ],
      "material": "metal",
      "note": "hall road door lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -3.5,
        3.4,
        16.44
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.44
      ],
      "material": "metal",
      "note": "hall road door lamp outside fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -6.5,
        3.77,
        3
      ],
      "halfExtents": [
        0.04,
        1.27,
        0.04
      ],
      "material": "metal",
      "note": "A lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        6.5,
        3.77,
        3
      ],
      "halfExtents": [
        0.04,
        1.27,
        0.04
      ],
      "material": "metal",
      "note": "A lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -26,
        3.6,
        -34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "squeaky lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -14,
        3.6,
        -34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "squeaky lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -2,
        3.6,
        -34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "squeaky lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.18,
        -24
      ],
      "halfExtents": [
        0.04,
        0.12,
        0.04
      ],
      "material": "metal",
      "note": "pit lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        16,
        2.18,
        -24
      ],
      "halfExtents": [
        0.04,
        0.12,
        0.04
      ],
      "material": "metal",
      "note": "pit lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        8,
        2.18,
        -31
      ],
      "halfExtents": [
        0.04,
        0.12,
        0.04
      ],
      "material": "metal",
      "note": "pit lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        16,
        2.18,
        -31
      ],
      "halfExtents": [
        0.04,
        0.12,
        0.04
      ],
      "material": "metal",
      "note": "pit lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -36,
        4.5,
        34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "road lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -24,
        4.5,
        34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "road lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -12,
        4.5,
        34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "road lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        0,
        4.5,
        34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "road lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        12,
        4.5,
        34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "road lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        24,
        4.5,
        34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "road lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        36,
        4.5,
        34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "road lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        25,
        3.325,
        0
      ],
      "halfExtents": [
        0.04,
        0.175,
        0.04
      ],
      "material": "metal",
      "note": "control room lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        20.65,
        3.2,
        -3.5
      ],
      "halfExtents": [
        0.35,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "control room west lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        29.35,
        3.2,
        2.5
      ],
      "halfExtents": [
        0.35,
        0.04,
        0.04
      ],
      "material": "metal",
      "note": "control room east lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        27,
        3.2,
        -6.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.35
      ],
      "material": "metal",
      "note": "control room north lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        23,
        3.2,
        6.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.35
      ],
      "material": "metal",
      "note": "control room south lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        33.6,
        1.475,
        -8
      ],
      "halfExtents": [
        0.04,
        1.465,
        0.04
      ],
      "material": "metal",
      "note": "yard wall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        33.6,
        1.475,
        10
      ],
      "halfExtents": [
        0.04,
        1.465,
        0.04
      ],
      "material": "metal",
      "note": "yard wall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        19.2,
        3.57,
        -13
      ],
      "halfExtents": [
        0.04,
        0.07,
        0.04
      ],
      "material": "metal",
      "note": "blast wall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        19.2,
        3.57,
        13
      ],
      "halfExtents": [
        0.04,
        0.07,
        0.04
      ],
      "material": "metal",
      "note": "blast wall lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        32,
        3.6,
        -34.35
      ],
      "halfExtents": [
        0.04,
        0.04,
        0.15
      ],
      "material": "metal",
      "note": "south-east lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -32,
        0.605,
        0
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        0.605,
        30
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.605,
        24
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    },
    {
      "kind": "box",
      "center": [
        34,
        0.605,
        0
      ],
      "halfExtents": [
        1.58,
        0.595,
        0.39
      ],
      "material": "sand",
      "hidden": true,
      "note": "sandbag wall"
    }
  ],
  "spawns": [
    {
      "position": [
        -41.5,
        0.05,
        -9
      ],
      "yaw": 4.499,
      "team": 0
    },
    {
      "position": [
        42.5,
        0.05,
        -8
      ],
      "yaw": 1.757,
      "team": 1
    },
    {
      "position": [
        -41.5,
        0.05,
        -4
      ],
      "yaw": 4.616,
      "team": 0
    },
    {
      "position": [
        42.5,
        0.05,
        -3
      ],
      "yaw": 1.641,
      "team": 1
    },
    {
      "position": [
        -41.5,
        0.05,
        2
      ],
      "yaw": 4.761,
      "team": 0
    },
    {
      "position": [
        42.5,
        0.05,
        3
      ],
      "yaw": 1.5,
      "team": 1
    },
    {
      "position": [
        -41.5,
        0.05,
        7
      ],
      "yaw": 4.879,
      "team": 0
    },
    {
      "position": [
        42.5,
        0.05,
        8
      ],
      "yaw": 1.385,
      "team": 1
    },
    {
      "position": [
        -38.5,
        0.05,
        -9
      ],
      "yaw": 4.483,
      "team": 0
    },
    {
      "position": [
        39.5,
        0.05,
        -8
      ],
      "yaw": 1.771,
      "team": 1
    },
    {
      "position": [
        -38.5,
        0.05,
        -4
      ],
      "yaw": 4.609,
      "team": 0
    },
    {
      "position": [
        39.5,
        0.05,
        -3
      ],
      "yaw": 1.647,
      "team": 1
    },
    {
      "position": [
        -38.5,
        0.05,
        2
      ],
      "yaw": 4.764,
      "team": 0
    },
    {
      "position": [
        39.5,
        0.05,
        3
      ],
      "yaw": 1.495,
      "team": 1
    },
    {
      "position": [
        -38.5,
        0.05,
        7
      ],
      "yaw": 4.892,
      "team": 0
    },
    {
      "position": [
        39.5,
        0.05,
        8
      ],
      "yaw": 1.371,
      "team": 1
    }
  ],
  "props": [
    {
      "model": "/game/models/props/box-large.glb",
      "position": [
        -33,
        0.01,
        -15
      ],
      "note": "yard crate"
    },
    {
      "model": "/game/models/props/box-large.glb",
      "position": [
        -33,
        0.01,
        17
      ],
      "note": "yard crate"
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -32,
        0.01,
        0
      ]
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        -43,
        0.01,
        -17
      ]
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        -43,
        0.01,
        19
      ]
    },
    {
      "model": "/game/models/hangar/desk_computer.glb",
      "position": [
        -23.5,
        0.01,
        -14.5
      ],
      "note": "lobby desk"
    },
    {
      "model": "/game/models/kit/crate.glb",
      "position": [
        -21,
        0.01,
        5
      ],
      "note": "hut crate"
    },
    {
      "model": "/game/models/hangar/machine_generatorLarge.glb",
      "position": [
        -23.5,
        0,
        -2
      ],
      "note": "mini transformer"
    },
    {
      "model": "/game/models/hangar/machine_generator.glb",
      "position": [
        12,
        0.01,
        -12
      ],
      "note": "hall generator"
    },
    {
      "model": "/game/models/hangar/machine_generator.glb",
      "position": [
        12,
        0.01,
        0
      ],
      "note": "hall generator"
    },
    {
      "model": "/game/models/hangar/machine_barrelLarge.glb",
      "position": [
        -12,
        0.01,
        2
      ],
      "note": "hall tank"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        -12,
        0.01,
        -13
      ],
      "note": "hall pipe"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        -9,
        0.01,
        -13
      ],
      "note": "hall pipe"
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        -13,
        0.01,
        -3
      ]
    },
    {
      "model": "/game/models/hangar/barrel.glb",
      "position": [
        13,
        0.01,
        8
      ]
    },
    {
      "model": "/game/models/kit/crate-color.glb",
      "position": [
        -7,
        0.01,
        -3
      ],
      "note": "hall crate"
    },
    {
      "model": "/game/models/kit/crate-color.glb",
      "position": [
        7,
        0.01,
        -14
      ],
      "note": "hall crate"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        -20,
        0.01,
        -33.2
      ],
      "note": "squeaky pipe"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        -16.8,
        0.01,
        -33.2
      ],
      "note": "squeaky pipe"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        -13.6,
        0.01,
        -33.2
      ],
      "note": "squeaky pipe"
    },
    {
      "model": "/game/models/props/box-large.glb",
      "position": [
        -8,
        0.01,
        -26
      ],
      "note": "squeaky crate"
    },
    {
      "model": "/game/models/hangar/barrels_rail.glb",
      "position": [
        -2,
        0.01,
        -32.5
      ]
    },
    {
      "model": "/game/models/hangar/machine_generatorLarge.glb",
      "position": [
        12,
        -2.5,
        -27.5
      ],
      "note": "pit turbine"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        7,
        -2.5,
        -31.5
      ],
      "note": "pit pipe"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        17,
        -2.5,
        -31.5
      ],
      "note": "pit pipe"
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        5.5,
        -2.5,
        -21.5
      ]
    },
    {
      "model": "/game/models/hangar/barrel.glb",
      "position": [
        18.5,
        -2.5,
        -22
      ]
    },
    {
      "model": "/game/models/hangar/machine_generatorLarge.glb",
      "position": [
        -10,
        0.01,
        18
      ],
      "note": "north transformer"
    },
    {
      "model": "/game/models/hangar/machine_generatorLarge.glb",
      "position": [
        8,
        0.01,
        18
      ],
      "note": "north transformer"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        -24,
        0.01,
        33.3
      ],
      "note": "road pipe"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        -20.8,
        0.01,
        33.3
      ],
      "note": "road pipe"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        20.8,
        0.01,
        33.3
      ],
      "note": "road pipe"
    },
    {
      "model": "/game/models/hangar/pipe_straight.glb",
      "position": [
        24,
        0.01,
        33.3
      ],
      "note": "road pipe"
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        0,
        0.01,
        30
      ]
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        -30,
        0.01,
        24
      ]
    },
    {
      "model": "/game/models/props/box-large.glb",
      "position": [
        30,
        0.01,
        31
      ],
      "note": "road crate"
    },
    {
      "model": "/game/models/hangar/desk_computer.glb",
      "position": [
        25,
        0.01,
        4.5
      ],
      "note": "control desk"
    },
    {
      "model": "/game/models/hangar/desk_computer.glb",
      "position": [
        25,
        0.01,
        -4.5
      ],
      "note": "control desk"
    },
    {
      "model": "/game/models/props/box-large.glb",
      "position": [
        35,
        0.01,
        -13
      ],
      "note": "defenders crate"
    },
    {
      "model": "/game/models/props/box-large.glb",
      "position": [
        35,
        0.01,
        15
      ],
      "note": "defenders crate"
    },
    {
      "model": "/game/models/urban/sandbags.glb",
      "position": [
        34,
        0.01,
        0
      ]
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        43,
        0.01,
        -14
      ]
    },
    {
      "model": "/game/models/props/box-large.glb",
      "position": [
        28,
        0.01,
        -26
      ],
      "note": "south-east crate"
    },
    {
      "model": "/game/models/hangar/barrels.glb",
      "position": [
        40,
        0.01,
        -32
      ]
    }
  ],
  "lights": [
    {
      "kind": "spot",
      "position": [
        -43.5,
        8.2,
        -17
      ],
      "color": "#e8f0ff",
      "intensity": 320,
      "distance": 30,
      "target": [
        -36,
        0,
        -5.1
      ],
      "angle": 0.7,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "yard flood"
    },
    {
      "kind": "spot",
      "position": [
        -43.5,
        8.2,
        19
      ],
      "color": "#e8f0ff",
      "intensity": 320,
      "distance": 30,
      "target": [
        -36,
        0,
        5.7
      ],
      "angle": 0.7,
      "penumbra": 0.4,
      "note": "yard flood"
    },
    {
      "kind": "point",
      "position": [
        -30.6,
        3,
        -4
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 10,
      "note": "yard wall lamp"
    },
    {
      "kind": "point",
      "position": [
        -30.6,
        3,
        8
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 10,
      "note": "yard wall lamp"
    },
    {
      "kind": "point",
      "position": [
        -23.5,
        3.1,
        -11.5
      ],
      "color": "#fff4dc",
      "intensity": 45,
      "distance": 9,
      "note": "lobby lamp"
    },
    {
      "kind": "point",
      "position": [
        -23.5,
        3.1,
        7.5
      ],
      "color": "#fff4dc",
      "intensity": 45,
      "distance": 9,
      "note": "hut lamp"
    },
    {
      "kind": "point",
      "position": [
        -18.6,
        3.2,
        -6
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "mini lamp"
    },
    {
      "kind": "point",
      "position": [
        -18.6,
        3.2,
        2
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "mini lamp"
    },
    {
      "kind": "spot",
      "position": [
        0,
        8.4,
        -2
      ],
      "color": "#fff1d6",
      "intensity": 400,
      "distance": 24,
      "target": [
        0,
        0,
        4
      ],
      "angle": 0.9,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "hall flood"
    },
    {
      "kind": "point",
      "position": [
        -10,
        7.2,
        -13
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        -10,
        7.2,
        -1
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        -10,
        7.2,
        11
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        7.2,
        -13
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        7.2,
        -1
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        7.2,
        11
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        10,
        7.2,
        -13
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        10,
        7.2,
        -1
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        10,
        7.2,
        11
      ],
      "color": "#fff1d6",
      "intensity": 90,
      "distance": 16,
      "note": "hall lamp"
    },
    {
      "kind": "point",
      "position": [
        -15,
        3.4,
        -10.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall west door lamp"
    },
    {
      "kind": "point",
      "position": [
        -17,
        3.4,
        -10.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall west door lamp outside"
    },
    {
      "kind": "point",
      "position": [
        -15,
        3.4,
        9.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall west door lamp"
    },
    {
      "kind": "point",
      "position": [
        -17,
        3.4,
        9.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall west door lamp outside"
    },
    {
      "kind": "point",
      "position": [
        15,
        3.4,
        -4.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall east door lamp"
    },
    {
      "kind": "point",
      "position": [
        17,
        3.4,
        -4.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall east door lamp outside"
    },
    {
      "kind": "point",
      "position": [
        15,
        3.4,
        5.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall east door lamp"
    },
    {
      "kind": "point",
      "position": [
        17,
        3.4,
        5.5
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall east door lamp outside"
    },
    {
      "kind": "point",
      "position": [
        12,
        3.4,
        -17
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall pit door lamp"
    },
    {
      "kind": "point",
      "position": [
        12,
        3.4,
        -19
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall pit door lamp outside"
    },
    {
      "kind": "point",
      "position": [
        -3.5,
        3.4,
        15
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall road door lamp"
    },
    {
      "kind": "point",
      "position": [
        -3.5,
        3.4,
        17
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "hall road door lamp outside"
    },
    {
      "kind": "point",
      "position": [
        -6.5,
        5.1,
        3
      ],
      "color": "#fff1d6",
      "intensity": 50,
      "distance": 10,
      "note": "A lamp"
    },
    {
      "kind": "point",
      "position": [
        6.5,
        5.1,
        3
      ],
      "color": "#fff1d6",
      "intensity": 50,
      "distance": 10,
      "note": "A lamp"
    },
    {
      "kind": "point",
      "position": [
        -26,
        3.6,
        -34.1
      ],
      "color": "#e8f0ff",
      "intensity": 45,
      "distance": 11,
      "note": "squeaky lamp"
    },
    {
      "kind": "point",
      "position": [
        -14,
        3.6,
        -34.1
      ],
      "color": "#e8f0ff",
      "intensity": 45,
      "distance": 11,
      "note": "squeaky lamp"
    },
    {
      "kind": "point",
      "position": [
        -2,
        3.6,
        -34.1
      ],
      "color": "#e8f0ff",
      "intensity": 45,
      "distance": 11,
      "note": "squeaky lamp"
    },
    {
      "kind": "point",
      "position": [
        8,
        2,
        -24
      ],
      "color": "#ffe9c4",
      "intensity": 70,
      "distance": 12,
      "note": "pit lamp"
    },
    {
      "kind": "point",
      "position": [
        16,
        2,
        -24
      ],
      "color": "#ffe9c4",
      "intensity": 70,
      "distance": 12,
      "note": "pit lamp"
    },
    {
      "kind": "point",
      "position": [
        8,
        2,
        -31
      ],
      "color": "#ffe9c4",
      "intensity": 70,
      "distance": 12,
      "note": "pit lamp"
    },
    {
      "kind": "point",
      "position": [
        16,
        2,
        -31
      ],
      "color": "#ffe9c4",
      "intensity": 70,
      "distance": 12,
      "note": "pit lamp"
    },
    {
      "kind": "point",
      "position": [
        1.5,
        3.4,
        -27
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "pit west stair lamp"
    },
    {
      "kind": "point",
      "position": [
        22.5,
        3.4,
        -30
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 9,
      "note": "pit east stair lamp"
    },
    {
      "kind": "point",
      "position": [
        -36,
        4.5,
        34.1
      ],
      "color": "#e8f0ff",
      "intensity": 60,
      "distance": 14,
      "note": "road lamp"
    },
    {
      "kind": "point",
      "position": [
        -24,
        4.5,
        34.1
      ],
      "color": "#e8f0ff",
      "intensity": 60,
      "distance": 14,
      "note": "road lamp"
    },
    {
      "kind": "point",
      "position": [
        -12,
        4.5,
        34.1
      ],
      "color": "#e8f0ff",
      "intensity": 60,
      "distance": 14,
      "note": "road lamp"
    },
    {
      "kind": "point",
      "position": [
        0,
        4.5,
        34.1
      ],
      "color": "#e8f0ff",
      "intensity": 60,
      "distance": 14,
      "note": "road lamp"
    },
    {
      "kind": "point",
      "position": [
        12,
        4.5,
        34.1
      ],
      "color": "#e8f0ff",
      "intensity": 60,
      "distance": 14,
      "note": "road lamp"
    },
    {
      "kind": "point",
      "position": [
        24,
        4.5,
        34.1
      ],
      "color": "#e8f0ff",
      "intensity": 60,
      "distance": 14,
      "note": "road lamp"
    },
    {
      "kind": "point",
      "position": [
        36,
        4.5,
        34.1
      ],
      "color": "#e8f0ff",
      "intensity": 60,
      "distance": 14,
      "note": "road lamp"
    },
    {
      "kind": "point",
      "position": [
        25,
        3.1,
        0
      ],
      "color": "#fff4dc",
      "intensity": 50,
      "distance": 10,
      "note": "control room lamp"
    },
    {
      "kind": "point",
      "position": [
        20.2,
        3.2,
        -3.5
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "control room west lamp"
    },
    {
      "kind": "point",
      "position": [
        29.8,
        3.2,
        2.5
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "control room east lamp"
    },
    {
      "kind": "point",
      "position": [
        27,
        3.2,
        -6.8
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "control room north lamp"
    },
    {
      "kind": "point",
      "position": [
        23,
        3.2,
        6.8
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "control room south lamp"
    },
    {
      "kind": "spot",
      "position": [
        43.5,
        8.2,
        -14
      ],
      "color": "#e8f0ff",
      "intensity": 320,
      "distance": 30,
      "target": [
        37,
        0,
        -4.2
      ],
      "angle": 0.7,
      "penumbra": 0.4,
      "note": "yard flood"
    },
    {
      "kind": "spot",
      "position": [
        43.5,
        8.2,
        16
      ],
      "color": "#e8f0ff",
      "intensity": 320,
      "distance": 30,
      "target": [
        37,
        0,
        4.8
      ],
      "angle": 0.7,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "yard flood"
    },
    {
      "kind": "point",
      "position": [
        33.6,
        3,
        -8
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 10,
      "note": "yard wall lamp"
    },
    {
      "kind": "point",
      "position": [
        33.6,
        3,
        10
      ],
      "color": "#e8f0ff",
      "intensity": 40,
      "distance": 10,
      "note": "yard wall lamp"
    },
    {
      "kind": "point",
      "position": [
        19.2,
        3.7,
        -13
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "blast wall lamp"
    },
    {
      "kind": "point",
      "position": [
        19.2,
        3.7,
        13
      ],
      "color": "#e8f0ff",
      "intensity": 35,
      "distance": 9,
      "note": "blast wall lamp"
    },
    {
      "kind": "point",
      "position": [
        32,
        3.6,
        -34.1
      ],
      "color": "#e8f0ff",
      "intensity": 45,
      "distance": 11,
      "note": "south-east lamp"
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        0,
        2.54,
        8
      ],
      "halfExtents": [
        4,
        2,
        3
      ]
    },
    {
      "id": "B",
      "center": [
        12,
        -2.46,
        -24.5
      ],
      "halfExtents": [
        4,
        2,
        3
      ]
    }
  ]
}
